/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import { useEffect, useState} from "react";
import {ExdsIconDiamondFilled} from "@exds/icons";
import {ExdsLayout, ExdsText} from "@exds/core";
import classNames from 'classnames';
import Requirement from "./Requirement";
import AfterSubmitCheck from "./AfterSubmitCheck";

export default function PasswordRequirements(props) {
  const {requirements, afterSubmitChecks, activeRequirementsBox, passwordValue, requirementsMet} = props;
  const [invalidRequirements, setInvalidRequirements] = useState(false);
  const totalRequirements = requirements?.validationRules.length;

  const requirementsStyling = classNames({
    'invalid': invalidRequirements,
    'active': activeRequirementsBox,
    'requirements-met': requirementsMet === totalRequirements,
  });

  useEffect(() => {
    setInvalidRequirements(passwordValue && document.querySelectorAll('.invalid-text').length > 0);
  }, [passwordValue]);

  const sortedValidationRules = () => {
    const reqs = requirements?.validationRules;
    return reqs.sort((req1, req2) => req1.order - req2.order);
  };

  return (
    <>
      <ExdsIconDiamondFilled
        size="large"
        color="error"
        className={`diamond-icon ${requirementsStyling}`}
      />
      <div className={`requirements-container ${requirementsStyling}`}>
        {sortedValidationRules().map((req, key) =>
          <Requirement req={req} key={key} passwordValue={passwordValue}/>
        )}

        {afterSubmitChecks && (
          <>
            <ExdsLayout display="flex" flexDirection="row" justifyContent="center" gap="1.5rem" alignItems="center">
              <div className="vector" />
              <ExdsText textStyle="bodyMedium" className="req-text fw-300">Checked after submit</ExdsText>
              <div className="vector" />
            </ExdsLayout>

            {afterSubmitChecks.map((check, key) => <AfterSubmitCheck check={check} key={key}/>)}
          </>
        )}
      </div>
    </>
  );
};
